import React, { useState } from 'react';
import { GridContainer, Card, CardTitle, CardContent } from '../styles/PoulationPreferences.styles';
import populationPreferencesData from '../data/populationPreferencesData'; // Adjust the import path as needed

const PopulationPreferences = () => {
    // Set the initial state to open all cards (i.e., all indices in the array)
    const [openIndexes, setOpenIndexes] = useState(
        populationPreferencesData.map((_, index) => index) // Initially open all cards
    );

    // Toggle visibility: If index is in openIndexes, remove it (close the card), otherwise add it (open the card)
    const toggleCard = (index) => {
        setOpenIndexes((prevIndexes) => {
            if (prevIndexes.includes(index)) {
                return prevIndexes.filter(i => i !== index); // Close the card
            } else {
                return [...prevIndexes, index]; // Open the card
            }
        });
    };

    return (
        <div>
            <h2>Population and Preferences</h2>
            <p>Click a tile to hide/view population preferences.</p>
            <GridContainer>
                {populationPreferencesData.map((segment, index) => (
                    <Card key={index} onClick={() => toggleCard(index)}>
                        <CardTitle>{segment.title}</CardTitle>
                        {/* Content will toggle based on the openIndexes state */}
                        {openIndexes.includes(index) && (
                            <CardContent>
                                {/* Split the content by newline and render as paragraphs */}
                                {segment.content.split('\n').map((paragraph, idx) => (
                                    <p key={idx}>{paragraph}</p>
                                ))}
                            </CardContent>
                        )}
                    </Card>
                ))}
            </GridContainer>
        </div>
    );
};

export default PopulationPreferences;
